import { BiogasviewDocument } from './../biogasview-document';

export class SiteDocumentDAO extends BiogasviewDocument{
	site: string;
	exported: boolean = false;
	thirdPartyExport: boolean = false;
}
